// Can't use styled-components as it doesn't work with Remix root boundaries
import * as styles from './VanillaErrorMessage.css'

export function VanillaErrorMessage({
  title,
  details,
}: {
  title: React.ReactNode
  details: React.ReactNode
}) {
  return (
    <div className={styles.root}>
      <details className={styles.box}>
        <summary className={styles.message}>{title}</summary>
        <pre className={styles.stack}>{details}</pre>
      </details>
    </div>
  )
}
